import T from 'i18n-react';

import { Badge, DealershipIcon } from '@motorway/mw-highway-code';

import texts from 'Components/texts.json';

T.setTexts(texts);

export const VehicleTradeBadge: React.FC = () => {
	return <Badge data-trade-badge icon={DealershipIcon} reverse={true} text={texts.trade.title} />;
};
